import { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import Searchimg from "../../../images/aktcorp/search-product-image.jpg";
import { Link, useLocation } from "react-router-dom";
import Searchproductdaynamic from "../Searchproductdaynamictwo";

const Submenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [steelSegmentOpen, setSteelSegmentOpen] = useState(false);
  const [showroomOpen, setShowroomOpen] = useState(false);
  const [aktAutomotiveOpen, setAktAutomotiveOpen] = useState(false);
  const [AKTSegmentOpen, setAKTSegmentOpen] = useState(false);
  const [aktToolsOpen, setAKTToolsOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY + 100) {
        setIsOpen(false);
        setSteelSegmentOpen(false);
        setAktAutomotiveOpen(false);
        setAKTSegmentOpen(false);
        setAKTToolsOpen(false);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleLinkClick = () => {
    setIsOpen(false);
    setSteelSegmentOpen(false);
    setAktAutomotiveOpen(false);
    setAKTSegmentOpen(false);
    setAKTToolsOpen(false);
  };

  return (
<div className="relative">
      {/* MAIN MENU ITEM */}
      <div
        className={`text-sm lg:text-base font-medium cursor-pointer text-gray-800 hover:text-bold transition-all duration-300
          ${isOpen ? "animate-bounce-custom font-bold" : ""}`}
        onClick={() => setIsOpen(!isOpen)} // Toggle submenu on click
        onMouseEnter={() => setIsOpen(true)} // Open on hover
      >
        BUSINESS SEGMENT
      </div>

      {/* SUBMENU DROPDOWN */}
      {isOpen && (
        <div
          className="fixed left-0 right-0 md:left-6 md:right-6 md:mt-3 bg-white z-50 rounded-none md:rounded-b-2xl transition-all duration-300 shadow-xl"
          onMouseEnter={() => setIsOpen(true)} // Keep open on hover
          onMouseLeave={() => setIsOpen(false)} // Close on mouse leave (optional)
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 border-t-2 border-gray-300 mt-3 md:p-10">
            {/* Search Box */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <Searchproductdaynamic setIsOpen={setIsOpen} />
            </div>

            {/* Image */}
            <div className="flex justify-center items-center">
              <img
                src={Searchimg}
                alt="Product Search"
                className="rounded-lg max-w-full md:w-full md:h-full object-cover"
              />
            </div>

            {/* Category List */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <ul className="space-y-4 text-[18px]">

                {/* AKT STEEL */}
                <li className="text-gray-700 cursor-pointer">
                  <span
                    className="flex justify-between items-center hover:text-blue-600"
                    onClick={() => setSteelSegmentOpen(!steelSegmentOpen)}
                  >
                    AKT STEEL
                    {steelSegmentOpen ? (
                      <ChevronUp className="w-5 h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </span>
                  {steelSegmentOpen && (
                    <ul className="ml-4 mt-2 border-l-2 border-gray-300 pl-3 space-y-1 text-base">
                      <li>
                        <Link
                          to="/division/structural-divisions"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/structural-divisions")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          STEEL STRUCTURE
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/division/steel-pipes"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/steel-pipes")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          STEEL PIPES
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/division/valve-&-flanges"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/valve-&-flanges")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          VALVE & FLANGES
                        </Link>
                      </li>
                      {/* Third-Level submenu trigger */}
                      <li className="cursor-pointer">
                        <span
                          className="flex justify-between items-center hover:text-blue-600"
                          onClick={() => setShowroomOpen(!showroomOpen)}
                        >
                          AKT SHOWROOM & WORKSHOPS PROJECTS
                          {showroomOpen ? (
                            <ChevronUp className="w-4 h-4 text-gray-500" />
                          ) : (
                            <ChevronDown className="w-4 h-4 text-gray-500" />
                          )}
                        </span>
                        {/*Third-Leve submenu */}
                        {showroomOpen && (
                          <ul className="ml-4 mt-1 border-l-2 border-gray-200 pl-3 space-y-1 text-sm">
                            <li>
                              <Link
                                to="/division/project-completed"
                                onClick={handleLinkClick}
                                className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/project-completed") ? "text-gray-800 font-bold" : ""
                                  }`}
                              >
                                PROJECTS COMPLETED
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    </ul>
                  )}
                </li>


                {/* AKT TRADING */}
                <li className="text-gray-700 cursor-pointer">
                  <span
                    className="flex justify-between items-center hover:text-blue-600"
                    onClick={() => setAKTSegmentOpen(!AKTSegmentOpen)}
                  >
                    AKT TRADING
                    {AKTSegmentOpen ? (
                      <ChevronUp className="w-5 h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </span>
                  {AKTSegmentOpen && (
                    <ul className="ml-4 mt-2 border-l-2 border-gray-300 pl-3 space-y-1 text-base">
                      {[
                        { label: "SEALENTS", path: "/division/Selment" },
                        { label: "AIRCRAFT MAINTENANCE SEALANT (RTV)", path: "/division/Rtv" },
                        { label: "ADHESIVES", path: "/division/Adhesives" },
                        // { label: "ROOF COATINGS", path: "/division/Roofcoating" },
                      ].map((item) => (
                        <li key={item.path}>
                          <Link
                            to={item.path}
                            onClick={handleLinkClick}
                            className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith(item.path)
                              ? "text-gray-800 font-bold"
                              : ""
                              }`}
                          >
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>

                {/* AKT AUTOMOTIVE */}
                <li className="text-gray-700 cursor-pointer">
                  <span
                    className="flex justify-between items-center hover:text-blue-600"
                    onClick={() => setAktAutomotiveOpen(!aktAutomotiveOpen)}
                  >
                    AKT AUTOMOTIVE
                    {aktAutomotiveOpen ? (
                      <ChevronUp className="w-5 h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </span>
                  {aktAutomotiveOpen && (
                    <ul className="ml-4 mt-2 border-l-2 border-gray-300 pl-3 space-y-1 text-base">
                      <li>
                        <Link
                          to="/division/akt-car-care"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/akt-car-care")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          AKT CAR CARE
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/division/akt-car-wash"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/akt-car-wash")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          AKT CAR WASH
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/division/powder-coating"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/powder-coating")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          AKT POWDER COATING
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/division/akt-quick-services"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/akt-quick-services")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          QUICK SERVICES
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/* AKT TOOLS */}
                <li className="text-gray-700 cursor-pointer">
                  <span
                    className="flex justify-between items-center hover:text-blue-600"
                    onClick={() => setAKTToolsOpen(!aktToolsOpen)}
                  >
                    AKT TOOLS DIVISION
                    {aktToolsOpen ? (
                      <ChevronUp className="w-5 h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </span>
                  {aktToolsOpen && (
                    <ul className="ml-4 mt-2 border-l-2 border-gray-300 pl-3 space-y-1 text-base">
                      <li>
                        <Link
                          to="/division/akt-tools-division"
                          onClick={handleLinkClick}
                          className={`block py-1 hover:text-blue-600 ${location.pathname.startsWith("/division/akt-tools-division")
                            ? "text-gray-800 font-bold"
                            : ""
                            }`}
                        >
                          AKT TOOLS
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Submenu;
